import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";
import { DescInput } from "./DescInput";
import { StyleKeyword } from "./StyleKeyword";
import { Age } from "./Age";

import "swiper/css";
/* 개발담당:양유빈
 * 화면기능:상품등록 > 상품등록
 * 세부설명:
*/

export class GoodsReg extends Component {
    static displayName = GoodsReg.name;

    constructor(props) {

        super(props);
        this.state = {
            GoodsMgtModel: {
                Goods_No: null,
                Goods_Nm: "",
                Goods_Price: "",
                Dtl_Content: "",
                Made_By: "KR",
                Public_Yn: "Y",
                Sinsale_Yn: "Y",
                SoldOut_Yn: "N",
                Strqst_Yn: false,
                Overseas_Yn:false,
                Use_Yn: "Y"
            },
            //색상
            GoodsCrdModel: [],
            GoodsCrdInfo: { Crd_Cd: "", Crd_Nm: "", Crd_No: "" },
            //사이즈
            GoodsSizModel: [],
            GoodsSizInfo: { Sizgrp_Cd: "", Siz_Cd: "", Siz_Nm: "" },
            //소재
            GoodsMatalModel: [],
            GoodsMatalInfo: { Matal_Cd: "", Matal_Nm: "", Ratio: "" },
            //소재정보
            GoodsMatchaModel: [],
            GoodsMatchaInfo: { Matcha_Grp: "", Matcha_Cd: "" },
            //세탁법
            GoodsLadryModel: [],
            GoodsLadryInfo: { Ladry_cd: "" },
            //이미지
            GoodsImgMgtModel: {
                File_Grp: "",
                Wmark_Yn: "N",
            },
            //카테고리
            CategoryModel: {
                Man_Cd: "",
                Man_Nm: "",
                Mid_Cd: "",
                Mid_Nm: "",
                Sub_Cd: "",
                Sub_Nm: ""
            },
            //스타일키워드
            StyleKeywordModel: [],
            StyleKeywordInfo: { Sty_Cd: "", Sty_Nm: ""},
            //연령대
            AgeModel: [],
            AgeInfo: { Age_Cd: "", Age_Nm: "" },
            Title: "",
            Content: "",
            ScrollY: 0,
            Input_Yn: "N",
            DtlSizeModel: []
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handlePrice_Click = this.handlePrice_Click.bind(this);
        this.handleComponent_Click = this.handleComponent_Click.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.handleMatchaSelect_Click = this.handleMatchaSelect_Click.bind(this);
        this.handleLadry_Chandge = this.handleLadry_Chandge.bind(this);
        this.handleImageDelete_Click = this.handleImageDelete_Click.bind(this);
        this.handleRegister_Click = this.handleRegister_Click.bind(this);
        this.handleCategory_Click = this.handleCategory_Click.bind(this);
        this.handleInputCheck_Click = this.handleInputCheck_Click.bind(this);
        this.handleDescInput_Click = this.handleDescInput_Click.bind(this);
        this.handleStyleClick = this.handleStyleClick.bind(this);
        this.handleAgeClick = this.handleAgeClick.bind(this);
        this.handleCallBack = this.handleCallBack.bind(this);
        this.refDescInput = React.createRef();
        this.StyleKeywordRef = React.createRef();
        this.AgeRef = React.createRef();
    }

    //초기화
    async componentDidMount() {
        
        //기본데이터 바인딩 리스트--> forceUpdate 필요
        await this.BaseInfoDataCall();
        //State값 설정
        const goods_no = Big3Common.Util.GetParams("goods_no");
        if (this.props.ContentState !== null) {
            
            const resovle = await Big3Common.setContentStateBind(this);
            if (resovle) {
                let File_Grp = this.state.GoodsImgMgtModel.File_Grp;
                if (File_Grp !== "") {
                    //--> forceUpdate 필요
                    await this.CallPhotoData(File_Grp);
                }
                this.MoneyFormat(this.state.GoodsMgtModel.Goods_Price);
               
            }
            //사이즈 변경시 다시 셋업 필요 ==> 세부 사이즈 변경이 됨으로
            if (this.props.ContentState.GoodsSizModel !== null) {
                const list1 = this.state.DtlSizeModel;
                const list2 = this.props.ContentState.GoodsSizModel;
                const validNames = list2.map(item => item.Siz_Nm);
                const filtered = list1.filter(item => validNames.includes(item.siz_gnm));
                this.setState(prevState => ({
                    ...prevState,
                    DtlSizeModel: filtered
                }));
            }
            window.scrollTo(0, this.state.ScrollY);
        }
        else {
            if (goods_no !== null) {
                //Data 호출 --> forceUpdate 필요
                await this.CallGoodsData(goods_no);
            }
        }
        //CRUD 상태 처리
        if (this.state.GoodsMgtModel.Goods_No !== null && this.state.GoodsMgtModel.Goods_No !== "") {
            Big3Common.LifeState.CRUD = "U";
        }
        else {
            Big3Common.LifeState.CRUD = "I";
        }
        this.forceUpdate();
    }
    //수정시 저장된 DB 호출
    async CallGoodsData(goods_no) {
        try {

            let Data = await Big3Common.Get(`api/Goods/GoodsMgr/GetGoodsDtl/${goods_no}`, this.state, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                
                DataList.GoodsMgtModel[0].strqst_yn = DataList.GoodsMgtModel[0].strqst_yn === "Y" ? true : false;
                DataList.GoodsMgtModel[0].overseas_yn = DataList.GoodsMgtModel[0].overseas_yn === "Y" ? true : false;
                Big3Common.setBindModel({ this: this, modelName: "CategoryModel", bindModel: DataList.CategoryModel });
                Big3Common.setBindModel({ this: this, modelName: "GoodsMgtModel", bindModel: DataList.GoodsMgtModel });
                Big3Common.setBindModel({ this: this, modelName: "GoodsImgMgtModel", bindModel: DataList.GoodsImgMgtModel });
                Big3Common.setBindModel({ this: this, modelName: "GoodsCrdModel", bindModel: DataList.GoodsCrdModel }, this.state.GoodsCrdInfo);
                Big3Common.setBindModel({ this: this, modelName: "GoodsSizModel", bindModel: DataList.GoodsSizModel }, this.state.GoodsSizInfo);

                Big3Common.setBindModel({ this: this, modelName: "GoodsMatalModel", bindModel: DataList.GoodsMatalModel }, this.state.GoodsMatalInfo);
                Big3Common.setBindModel({ this: this, modelName: "GoodsMatchaModel", bindModel: DataList.GoodsMatchaModel }, this.state.GoodsMatchaInfo);
                Big3Common.setBindModel({ this: this, modelName: "GoodsLadryModel", bindModel: DataList.GoodsLadryModel }, this.state.GoodsLadryInfo);
                Big3Common.setBindModel({ this: this, modelName: "StyleKeywordModel", bindModel: DataList.StyleKeywordModel }, this.state.StyleKeywordInfo);
                Big3Common.setBindModel({ this: this, modelName: "AgeModel", bindModel: DataList.AgeModel }, this.state.AgeInfo);
                Big3Common.setBindModel({ this: this, modelName: "DtlSizeModel", bindModel: DataList.DtlSizeModel });
                              
                let File_Grp = this.state.GoodsImgMgtModel.File_Grp;
                if (File_Grp !== "") {
                    //--> forceUpdate 필요
                    await this.CallPhotoData(File_Grp);
                }

                this.MoneyFormat(this.state.GoodsMgtModel.Goods_Price);
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGoodsData: ", e)
        }
        return false;
    }
    async CallPhotoData(File_Grp) {
        try {
            let Data = await Big3Common.Get(`api/Goods/GoodsReg/TempGoodsImage/${File_Grp}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                this.GoodsDataSetProp.GoodsImageListModel = DataList;
            }
        }
        catch (e) {
            console.log("CallPhotoData: ", e)
        }
    }
    GoodsDataSetProp = {
        GoodsMatchaModel: [],           //소재정보 DB값
        GoodsLadryModel: [],            //세탁정보 DB값
        GoodsProductModel: [],          //제조국
        GoodsImageListModel: [],        //임시저장 이미지.
        GoodsCategoryHistoryModel: [],  //임시저장 이미지.
        DtlSizeModelAll: []             //카테고리별 상세 사이즈
    }
    async BaseInfoDataCall() {
        try {

            let Data = await Big3Common.Get(`api/Goods/GoodsReg/GoodsRegBaseCode`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                let matchaList = DataList["matcha"]; //소재정보
                let ladryList = DataList["ladry"];   //세탁법
                let productList = DataList["product"]; //제조국
                let categoryList = DataList["category"]; //이전카테고리 리스트 
                let dtlsize = DataList["dtlsize"];
                this.GoodsDataSetProp.GoodsMatchaModel = matchaList;
                this.GoodsDataSetProp.GoodsLadryModel = ladryList;
                this.GoodsDataSetProp.GoodsProductModel = productList;
                this.GoodsDataSetProp.GoodsCategoryHistoryModel = categoryList;
                this.GoodsDataSetProp.DtlSizeModelAll = dtlsize;
            }
            else {
                console.log("등록된 데이터가 없습니다.");
            }
        }
        catch (e) {
            console.log("BaseInfoDataCall: ", e)
        }

        return false;
    }
    
    handleChange(event) {

        let tagId = event.target.id;
        let value = event.target.value.trim();
        
        if (tagId === "Goods_Price") {
            //핸드폰,인증번호 숫자만 입력 되게 처리
            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
        }
        if (tagId.includes("dtlsize_")) {
            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
            const siz_no = event.target.getAttribute("siz_no");
            const siz_type = event.target.getAttribute("siz_type");
            const siz_gnm = event.target.getAttribute("siz_gnm");

            let DtlSizeModel = this.state.DtlSizeModel;
            const index = DtlSizeModel.findIndex(item => item.siz_type === siz_type && item.siz_no.toString() === siz_no.toString() && item.siz_gnm.toString() === siz_gnm);
            if (value === "") {
                if (index !== -1) {
                    DtlSizeModel.splice(index, 1); // 해당 인덱스 항목 삭제
                }
            }
            else if (index !== -1) {
                // 이미 존재하면 업데이트
                DtlSizeModel[index].siz = value;
            } else {
                // 존재하지 않으면 새로 삽입
                DtlSizeModel.push({ siz_type, siz_no, siz: value, siz_gnm });
            }
            this.setState(prevState => ({
                ...prevState,  
                DtlSizeModel: DtlSizeModel 
            }));
            return false;
        }

        //변경상태 확인 플래그
        this.setState({ Input_Yn: "Y" });
        Big3Common.ValueCahage_StateUpdate({ this: this, event: event, modelName: "GoodsMgtModel" });      
        return false;
    }
    handleLadry_Chandge(event) {

        let tgaID = event.target.id;
        if (event.target.checked) {
            let GoodsLadryInfo = Big3Common.Util.Cloen(this.state.GoodsLadryInfo);
            GoodsLadryInfo.Ladry_cd = tgaID;
            this.state.GoodsLadryModel.push(GoodsLadryInfo);
        }
        else {
            Big3Common.Util.RemoveModelListRow(this.state.GoodsLadryModel, "Ladry_cd", tgaID);
        }
        this.forceUpdate();
    }
    handleBlur(event) {
        let tagId = event.target.id;
        let value = event.target.value.trim();
        if (tagId === "Goods_Price") {
            let moneyValue = Big3Common.Util.Money(value);
            document.getElementById(tagId).value = moneyValue
        }
        return false;
    }
    //상품단가 이벤트
    handlePrice_Click(event, money) {

        let goodsprice = this.state.GoodsMgtModel.Goods_Price;
        let thisMoney = 0;
        thisMoney = goodsprice === "" ? parseInt(money) : (parseInt(goodsprice) + parseInt(money));
        Big3Common.updateStateModel({ this: this, modelName: "GoodsMgtModel", updateModel: { "Goods_Price": thisMoney } })
        let moneyValue = Big3Common.Util.Money(thisMoney);
        this.MoneyFormat(moneyValue);

        event.preventDefault();
    }
    MoneyFormat(Value) {
        let moneyValue = Big3Common.Util.Money(Value);
        setTimeout(() => {
            document.getElementById("Goods_Price").value = moneyValue;
        }, 100);
    }
    //컴포넌트 이동
    handleComponent_Click(event, ComName) {
        if (ComName === "SizeReg") {
            if (this.state.CategoryModel.Man_Cd === "" && this.state.CategoryModel.Mid_Cd === "") {
                this.setState({ Title: "카테고리 선택 후 사이즈등록 가능합니다." });
                Big3Common.ModalAlert(bootstrap, 'GoodsRegAlert');
                return false;
            }
        }

        let StateCopy = Big3Common.WebStorage.StateStorage(this.state);
        StateCopy.ScrollY = window.scrollY;
        this.props.RenderComponent(ComName, StateCopy);
        event.preventDefault();
    }
    //선택된 객체의 값 삭제(색상, 사이즈)
    handleDelete_Click(event, ModelName, delKey, delNum) {
        let RemoveModelList = this.state[ModelName];
        const siz_nm = RemoveModelList.find(list => list.Siz_Cd === delNum).Siz_Nm;

        Big3Common.Util.RemoveModelListRow(RemoveModelList, delKey, delNum);

        //사이즈가 변경되면 DtlSizeModel 업데이트 처리
        const DtlSizeModel = this.state.DtlSizeModel.filter(list => list.siz_gnm !== siz_nm);
        this.setState(prevState => ({
            ...prevState,
            DtlSizeModel: DtlSizeModel
        }));
        this.forceUpdate();
        event.preventDefault();
    }
    //소재정보 선택
    handleMatchaSelect_Click(event, matcha_grp, matcha_cd) {

        let elementName = `matcha_${matcha_grp}`;
        let elementId = `${matcha_grp}_${matcha_cd}`;
        document.querySelectorAll(`div[name='${elementName}']`).forEach((Element) => {
            if (Element.id === elementId) {
                Element.className = "Material select";
                Big3Common.Util.RemoveModelListRow(this.state.GoodsMatchaModel, "Matcha_Grp", matcha_grp);
                let matcha = Big3Common.Util.Cloen(this.state.GoodsMatchaInfo);
                matcha.Matcha_Grp = matcha_grp;
                matcha.Matcha_Cd = matcha_cd;
                this.state.GoodsMatchaModel.push(matcha);
            }
            else {
                Element.className = "Material";
            }
        });
        event.preventDefault();
    }
    //사진 삭제
    async handleImageDelete_Click(event, file_no) {
        try {

            let Url = `api/Common/Common/RemoveFileDtl/${file_no}`;
            let Data = await Big3Common.Get(Url);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.Util.RemoveModelListRow(this.GoodsDataSetProp.GoodsImageListModel, "file_no", file_no);
                this.forceUpdate();
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("handleImageDelete_Click: ", e)
        }
    }
    //카테고리 히스토리 목록 클릭 시 값할당.==> 상세 사이즈 초기화
    handleCategory_Click(event, man_cd, mid_cd, sub_cd, man_nm, mid_nm, sub_nm) {
        this.setState(prevState => ({
            ...prevState,
            DtlSizeModel: [],
            CategoryModel: {
            Man_Cd: man_cd,
            Man_Nm: man_nm,
            Mid_Cd: mid_cd,
            Mid_Nm: mid_nm,
            Sub_Cd: sub_cd,
            Sub_Nm: sub_nm
            }
        }));
        event.preventDefault();
    }
    handleInputCheck_Click(event) {
        if (Big3Common.LifeState.CRUD === "I" && (this.state.Input_Yn === "Y" || this.state.GoodsImgMgtModel.File_Grp !== "")) {
            if (!window.confirm("변경 내용이 있습니다. 계속 진행하시겠습니까?")) {
                event.preventDefault();
            }
        }

    }
    //자동입력(1,2,3)
    handleDescInput_Click = (event, number) => {
        this.refDescInput.current.CallDescInputData(number);
        Big3Common.ModalAlert(bootstrap, 'DescInput');
        event.preventDefault();
    }
    //스타일키워드 입력
    handleStyleClick(event) {
        this.StyleKeywordRef.current.InitData();
        Big3Common.ModalAlert(bootstrap, 'StyleKeyword');
        event.preventDefault();
    }
    //연령대 입력
    handleAgeClick(event) {
        this.AgeRef.current.InitData();
        Big3Common.ModalAlert(bootstrap, 'Age');
        event.preventDefault();
    }
    //자동입력값 반환
    handleCallBack = (dtlContent) => {
        Big3Common.updateStateModel({ this: this, modelName: "GoodsMgtModel", updateModel: { "Dtl_Content": dtlContent } });
        return false;
    }
    handleStyleCallBack = (StyleKeywordModel) => {
        this.setState({
            StyleKeywordModel: StyleKeywordModel
        })
        return false;
    }
    handleAgeCallBack = (AgeModel) => {
        this.setState({
            AgeModel: AgeModel
        })
        return false;
    }
    ////상세 사이즈의 값이있는 상태에서 카테고리가 벼경되면 값을 초기화
    //ClearDtlSizeModel = () => {
    //    const CategoryModel = this.state.CategoryModel;
    //    const DtlSizeModel = this.state.DtlSizeModel;
    //    if (CategoryModel.length > 0 && DtlSizeModel.length > 0) {
    //        const Man_Cd = CategoryModel.Man_Cd;
    //        const Mid_Cd = CategoryModel.Mid_Cd;
    //        const Sub_Cd = CategoryModel.Sub_Cd;
    //        const DtlSizeModelAll = this.GoodsDataSetProp.DtlSizeModelAll.find(list => list.man_cd === Man_Cd && list.mid_cd === Mid_Cd && list.sub_cd === Sub_Cd);
    //        const siz_type = DtlSizeModelAll.siz_type;
    //        const DtlSize = DtlSizeModel.filter(list => list.siz_type === siz_type);
    //        //카테고리가 변경되었다면 DtlSizeModel 할당된 값 초기화
    //        if (DtlSize.length === 0) {
    //            this.setState(prevState => ({
    //                ...prevState,
    //                DtlSizeModel: []
    //            }));
    //        }
    //    }
    //    return false;
    //}
    //카테고리별 상세사이즈 항목
    GetCategoryDtlSize = () => {
        let DtlSize = [];
        if (this.state.GoodsMgtModel.Overseas_Yn === true) {
            let CategoryData = this.state.CategoryModel;
            if (CategoryData.Man_Cd !== "" && CategoryData.Mid_Cd !== "" && CategoryData.Sub_Cd !== "") {
                DtlSize = this.GoodsDataSetProp.DtlSizeModelAll.filter(data => data.man_cd === CategoryData.Man_Cd && data.mid_cd === CategoryData.Mid_Cd && data.sub_cd === CategoryData.Sub_Cd);
            }
        }
        return DtlSize;
    }
    async handleRegister_Click() {
        
        let Content = "";
        if (this.state.GoodsMgtModel.Goods_Nm.trim().length === 0) {
            Content = "상품명을 등록하여 주세요.";
        }
        else if (this.state.GoodsImgMgtModel.File_Grp === "") {
            Content = "상품사진을 등록하여 주세요.";
        }
        else if (this.state.GoodsMgtModel.Goods_Price === "") {
            Content = "상품단가를 등록하여 주세요.";
        }
        else if (this.state.GoodsMgtModel.Dtl_Content.trim().length === 0) {
            Content = "상품 상세 설명을 등록하여 주세요.";
        }
        else if (this.state.CategoryModel.Man_Cd.length === 0) {
            Content = "카테고리를 등록하여 주세요.";
        }
        else if (this.state.GoodsCrdModel.length === 0) {
            Content = "색상을 등록하여 주세요.";
        }
        else if (this.state.GoodsSizModel.length === 0) {
            Content = "사이즈를 등록하여 주세요.";
        }
        else if (this.state.GoodsMatalModel.length === 0) {
            Content = "소재를 등록하여 주세요.";
        }
        else if (this.state.GoodsMatchaModel.length < 4) {
            Content = "소재 정보를 모두 등록하여 주세요.";
        }
        else if (this.state.GoodsLadryModel.length === 0) {
            Content = "세탁법을 등록하여 주세요.";
        }         
        
        if (this.GetCategoryDtlSize().length > 0) {
            const DtlSize = this.GetCategoryDtlSize();          //세부 사이즈 기준정보
            if (DtlSize.length > 0) {
                const DtlSizeModel = this.state.DtlSizeModel;   //입력된 값

                const dtlsize_base_count = DtlSize.length;      //세부 사이즈 항목의 개수(가로 행의 Cell 개수)
                const goodssiz_count = this.state.GoodsSizModel.length;//실제 사이즈 항목의 개수
                const dtlsize_count = DtlSizeModel.length;      //실제 입력된 세부 사이즈 항목 개수(가로행 X 세로행 Cell 개수)
                const TotalInput = (dtlsize_base_count * goodssiz_count);
                if (dtlsize_count !== TotalInput) {
                    console.log("dtlsize_count", dtlsize_count, "TotalInput", TotalInput)
                    Content = "해외판매를 위해 상세 사이즈를 모두 입력하여주세요.";
                }
            }

        }

        if (Content.length > 0) {
            this.setState({ "Title": "상품등록", "Content": Content });
            Big3Common.ModalAlert(bootstrap, 'GoodsRegAlert');
            return false;
        }
        else {

            let Url = Big3Common.LifeState.CRUD === "U" ? "api/Goods/GoodsReg/ModifyGoods" : "api/Goods/GoodsReg/RegisterGoods";
            let Data = await Big3Common.Post(Url, this.state, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ "Title": "상품등록", "Content": Data.message });
                if (Big3Common.LifeState.CRUD === "U") {
                    Big3Common.ModalAlert(bootstrap, 'GoodsRegAlert');
                }
                else {
                    Big3Common.AdsPlugin.GOODS_END_EVENT();
                    Big3Common.ModalAlert(bootstrap, 'GoodsRegAlert');
                    window.location.href = "/Goods/GoodsMgr/Index";
                }
            }
            else {
                console.log(Data.message);
            }
        }
    }
    //카테고리 히스토리 리스트
    CategoryHistory() {
        let CategoryHistoryData = this.GoodsDataSetProp.GoodsCategoryHistoryModel;
        return (
            <div className="category_box">
                {
                    CategoryHistoryData.map(list =>
                        <ol className="breadcrumb"
                            key={`${list.man_cd}${list.mid_cd}${list.sub_cd}`}
                            onClick={(e) => this.handleCategory_Click(e, list.man_cd, list.mid_cd, list.sub_cd, list.man_nm, list.mid_nm, list.sub_nm)}
                        >
                            <li className="breadcrumb-item">{list.man_nm}</li>
                            <li className="breadcrumb-item">{list.mid_nm}</li>
                            <li className="breadcrumb-item">{list.sub_nm}</li>
                        </ol>
                    )
                }

            </div>
        )
    }
    //선택된 카테고리 랜더링
    Categoryrender() {
        let CategoryData = this.state.CategoryModel;
        let CategoryHistory = this.CategoryHistory();
        if (CategoryData.Man_Cd !== "") {
            return (
                <div className="resister_input_line">
                    <label>카테고리</label>
                    <div className="choice_box">
                        <div className="go_txt">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">{CategoryData.Man_Nm}</li>
                                <li className="breadcrumb-item">{CategoryData.Mid_Nm}</li>
                                <li className="breadcrumb-item">{CategoryData.Sub_Nm}</li>
                            </ol>
                        </div>
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'CategoryReg'); }}></div>
                    </div>
                    {CategoryHistory}
                </div>
            );
        }
        else {
            return (
                <div className="resister_input_line">
                    <label>카테고리</label>
                    <div className="choice_box">
                        <div className="go_txt">카테고리 선택하러 가기</div>
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'CategoryReg'); }}></div>
                    </div>
                    {CategoryHistory}
                </div>
            );
        }
    }
    //색상
    Colorender() {
        let GoodsCrdlist = this.state.GoodsCrdModel;
        if (GoodsCrdlist.length === 0) {
            return (
                <div className="resister_input_line">
                    <label>색상</label>
                    <div className="choice_box">
                        <div className="go_txt">색상 입력하러 가기</div>
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'ColorReg'); }}></div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="resister_input_line">
                    <label>색상</label>
                    <div className="choice_box_s">
                        {GoodsCrdlist.map(list =>
                            <div className="selected_item" key={list.Crd_Cd} >
                                <div className={list.Crd_Cd === "99" ? "selected_color no_color" : "selected_color"} style={{ backgroundColor: list.Crd_No }}></div>
                                <div className="selected_name">{list.Crd_Nm}</div>
                                <div className="item_delete" onClick={(e) => { this.handleDelete_Click(e, "GoodsCrdModel", "Crd_Cd", list.Crd_Cd) }}></div>
                            </div>
                        )}
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'ColorReg'); }}></div>
                    </div>
                </div>
            )
        }

    }
    //사이즈
    Sizerender() {
        let GoodsSizModel = this.state.GoodsSizModel;
        if (GoodsSizModel.length === 0) {
            return (
                <div className="resister_input_line">
                    <label>사이즈</label>
                    <div className="choice_box">
                        <div className="go_txt">사이즈 입력하러 가기</div>
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'SizeReg') }}></div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="resister_input_line">
                    <label>사이즈</label>
                    <div className="choice_box_s">
                        {GoodsSizModel.map(list =>
                            <div className="selected_item" key={list.Siz_Cd}>
                                <div className="selected_name">{list.Siz_Nm}</div>
                                <div className="item_delete" onClick={(e) => { this.handleDelete_Click(e, "GoodsSizModel", "Siz_Cd", list.Siz_Cd) }}></div>
                            </div>
                        )}
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'SizeReg') }}></div>
                    </div>
                </div>
            )
        }
    }
    //세부 사이즈
   SizeDtlrender() {
       let DtlSize = this.GetCategoryDtlSize();         //세부 사이즈 정보
       let DtlSizeModel = this.state.DtlSizeModel;      //입력된 세부 사이즈 정보
       const baseSizmodel = this.state.GoodsSizModel;   //기본 사이즈 정보

       if (DtlSize.length > 0) {
           return (
               <div className="resister_input_line">
                   <label>상세 사이즈(cm)</label>
                   {baseSizmodel.map((data) =>
                       <div className={`size_input_box ${DtlSize.length === 5 ? 'five-box' : ''}`} key={data.Siz_Nm}>
                           <div>{data.Siz_Nm}</div>
                           {DtlSize.map((list) =>
                               <div className="input-group" key={list.siz_no}>
                                   <input type="text"
                                       siz_no={list.siz_no}
                                       siz_type={list.siz_type}
                                       siz_gnm={data.Siz_Nm}
                                       className="form-control"
                                       maxLength="4"
                                       value={GetDtlSizeValue(list.siz_type, list.siz_no, DtlSizeModel, data.Siz_Nm)}
                                       id={`dtlsize_${list.siz_no}`}
                                       onChange={this.handleChange}
                                   />
                                   <span style={{ color: "#a7acb0" }}>{list.siz_nm}</span>
                               </div>
                           )}
                       </div>
                   )}

               </div>
           )
       }
       else {
           return (
               ""
           )
       }
       function GetDtlSizeValue(siz_type, siz_no, DtlSizeModel, siz_gnm) {
           let Values = DtlSizeModel.filter(data => data.siz_type === siz_type && data.siz_no.toString() === siz_no.toString() && data.siz_gnm.toString() === siz_gnm);
           if (Values.length > 0) {
               return Values[0].siz;
           }
           else {
               return "";
           }
              
       }
    }
    //소재
    Materialrender() {
        let GoodsMatalModel = this.state.GoodsMatalModel;
        if (GoodsMatalModel.length > 0) {
            return (
                <div className="resister_input_line">
                    <label>소재</label>
                    <div className="choice_box_s">
                        {
                            GoodsMatalModel.map(list =>
                                <div className="selected_item" key={list.Matal_Cd}>
                                    <div className="selected_name">{list.Matal_Nm} {list.Ratio} %</div>
                                    <div className="item_delete" onClick={(e) => { this.handleDelete_Click(e, "GoodsMatalModel", "Matal_Cd", list.Matal_Cd) }}></div>
                                </div>
                            )
                        }
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'MaterialReg') }} ></div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="resister_input_line">
                    <label>소재</label>
                    <div className="choice_box">
                        <div className="go_txt">소재 입력하러 가기</div>
                        <div className="go_arrow" onClick={(e) => { this.handleComponent_Click(e, 'MaterialReg') }} ></div>
                    </div>
                </div>
            )
        }
    }
    //소재정보
    Matcharender() {
        //소재정보 기준정보 값
        let GoodsMatchaModel = Big3Common.Util.groupBy(this.GoodsDataSetProp.GoodsMatchaModel, list => list.matgrp_nm);
        //선택된 state 값
        let GoodsMatchaModel2 = this.state.GoodsMatchaModel;
        //render에 바인됭 리스트
        let MatchaGrp = [];
        //소재정보 셋팅
        for (const item of GoodsMatchaModel.entries()) {
            //소재정보 리스트 세부 항목           
            let itemList = item[1];
            //클릭한 소재정보
            let SelectState = [];
            //소재정보에서 선택된 값이 있으면 설정
            itemList.forEach(function (items) {
                let EqualList = GoodsMatchaModel2.filter(list => list.Matcha_Grp === items.matcha_grp && list.Matcha_Cd === items.matcha_cd);
                if (EqualList.length > 0) {
                    SelectState = EqualList;
                }
            });
            MatchaGrp.push({ "matgrp_nm": item[0], "Childlist": item[1], "SelectState": SelectState[0] });
        }
        return (
            <div className="resister_input_line">
                <label>소재 정보</label>
                {
                    MatchaGrp.map(list =>
                        <div className="Material_select_box" key={list.matgrp_nm}>
                            <div className="title">{list.matgrp_nm}</div>
                            {
                                list.Childlist.map(childs =>
                                    <div className={list.SelectState !== undefined && list.SelectState.Matcha_Grp === childs.matcha_grp && list.SelectState.Matcha_Cd === childs.matcha_cd ? "Material select" : "Material"}
                                        key={childs.matcha_grp + '_' + childs.matcha_cd}
                                        onClick={(e) => this.handleMatchaSelect_Click(e, childs.matcha_grp, childs.matcha_cd)}
                                        id={childs.matcha_grp + '_' + childs.matcha_cd}
                                        name={'matcha_' + childs.matcha_grp}
                                    >{childs.matcha_nm}</div>
                                )
                            }
                        </div>
                    )}
            </div>
        )
    }
    //세탁법
    Ladryrender() {

        //세탁법 기준정보
        let GoodsLadryModel = this.GoodsDataSetProp.GoodsLadryModel;
        //3개씩 리스트로 출력하기 위한 정리작업
        let GoodsLadryList = [];
        let GoodsLadrySub = [];
        //클릭된 세탁법
        let SelectState = this.state.GoodsLadryModel;
        let idx = 1;
        GoodsLadryModel.map(list => {
            let dtl_cd = list.dtl_cd;
            let dtl_nm = list.dtl_nm;
            let selected = SelectState.filter(selectlist => selectlist.Ladry_cd === dtl_cd);
            let GoodsLadrySubJson = { Ladry_Cd: dtl_cd, dtl_nm: dtl_nm, selected: selected.length > 0 ? true : false };
            if (idx % 3 === 0) {
                let rootName = "root" + idx.toString();
                GoodsLadrySub.push(GoodsLadrySubJson);
                GoodsLadryList.push({ rootName: rootName, subName: GoodsLadrySub });
                GoodsLadrySub = [];
            }
            else {
                GoodsLadrySub.push(GoodsLadrySubJson);
            }
            idx++;
            return false;
        });
        GoodsLadryList.push({ rootName: 'root999', subName: GoodsLadrySub });
        return (
            <div className="resister_input_line">
                <label>세탁법</label>
                {GoodsLadryList.map(list =>
                    <div className="Material_select_box" key={list.rootName}>
                        {
                            list.subName.map(subList =>
                                <div className="form-check" key={Big3Common.getGuid()}>
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id={subList.Ladry_Cd}
                                        value={subList.Ladry_Cd}
                                        onChange={this.handleLadry_Chandge}
                                        checked={subList.selected}
                                    />
                                    <label className="form-check-label">
                                        {subList.dtl_nm}
                                    </label>
                                </div>
                            )
                        }
                    </div>
                )}

            </div>
        )
    }
    //제조국
    Productrender() {
        //MADE_BY
        let GoodsProductModel = this.GoodsDataSetProp.GoodsProductModel;
        return (
            <div className="resister_input_line">
                <label>제조국</label>
                <div className="country_select_box">
                    {GoodsProductModel.map(list =>
                        <div className="form-check" key={list.dtl_cd}>
                            <input className="form-check-input"
                                type="radio"
                                name='Made_By'
                                value={list.dtl_cd}
                                checked={list.dtl_cd === this.state.GoodsMgtModel.Made_By ? "checked" : ""}
                                onChange={this.handleChange}
                            />
                            <label className="form-check-label">
                                {list.dtl_nm}
                            </label>
                        </div>
                    )}
                </div>
            </div>
        )
    }
    ImageOverseasrender = () => {
        //해외판매 허용
        return (
            <div className="Usage_Consent">
                <p>*해외 및 더 많은 소매상인에게 판매되도록 이미지 사용에 동의해주세요.</p>
                <div className="Material_select_box">
                    <div className="form-check">
                        <input className="form-check-input"
                            type="checkbox"
                            id="Overseas_Yn"
                            onChange={this.handleChange}
                            checked={this.state.GoodsMgtModel.Overseas_Yn}
                        />
                        <label className="form-check-label">
                            이미지 사용에 동의합니다.
                        </label>
                    </div>
                </div>
            </div>
        )
    }
    GoodsImagerender() {
        //상품 이미지 스와이퍼
        let goodsimageList = this.GoodsDataSetProp.GoodsImageListModel;
        let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        let LayoutWidth = Big3Common.Util.offsetWidth();
        let slidersCount = 3;
        slidersCount = Math.ceil(LayoutWidth / 100) - 1;
        if (slidersCount >= 8) {
            slidersCount = 7;
        }
        else if (slidersCount < 3) {
            slidersCount = 3;
        }
        return (
            <div className="resister_input_line">
                <label>사진등록</label>
                <div className="photo_select_box">
                    <div className="photo_select_button" onClick={(e) => { this.handleComponent_Click(e, 'PhotoUpload'); }}>
                        <div className="camera"></div>
                        <div className="photo_number">({goodsimageList.length}/15)</div>
                    </div>
                    <Swiper watchSlidesProgress={true} slidesPerView={slidersCount} className="mySwiper">
                        <div>
                            {
                                goodsimageList.map(list =>
                                    <SwiperSlide key={list.file_no}
                                        className="photo_select"
                                        style={{ backgroundImage: `url(${VirtualRoot}${list.img_100})`, width: "65px", height: "65px" }}>
                                        <div className="photo_delete" onClick={(e) => this.handleImageDelete_Click(e, list.file_no)} />
                                    </SwiperSlide>
                                )}
                            <SwiperSlide style={{ width: "65px", height: "65px" }}>
                                {/* 공백*/}
                            </SwiperSlide>
                        </div>
                    </Swiper>
                </div>
                {this.ImageOverseasrender() }
            </div>
        )
    }
    //스타일키워드
    Stylerender() {
        let StyleKeywordModel = this.state.StyleKeywordModel;
        if (StyleKeywordModel.length > 0) {
            return (
                <div className="resister_input_line">
                    <label>스타일키워드 입력</label>
                    <div className="choice_box_s">
                        {
                            StyleKeywordModel.map(list =>
                                <div className="selected_item" key={list.Sty_Cd}>
                                    <div className="selected_name">{list.Sty_Nm}</div>
                                    <div className="item_delete" onClick={(e) => { this.handleDelete_Click(e, "StyleKeywordModel", "Sty_Cd", list.Sty_Cd) }}></div>
                                </div>
                            )
                        }
                        <div className="go_arrow" onClick={(e) => { this.handleStyleClick(e); }}></div>
                    </div>
                    <div className="input_txt_v2">※ 스타일키워드 입력은 필수등록사항은 아니지만 등록 시 상품상위 노출에 도움이 됩니다.</div>
                </div>
            )
        }
        else {
            return (
                <div className="resister_input_line">
                    <label>스타일키워드 입력</label>
                    <div className="choice_box">
                        <div className="go_txt">스타일 선택하기</div>
                        <div className="go_arrow" onClick={(e) => { this.handleStyleClick(e); }}></div>
                    </div>
                    <div className="input_txt_v2">※ 스타일키워드 입력은 필수등록사항은 아니지만 등록 시 상품상위 노출에 도움이 됩니다.</div>
                </div>
            )
        }
    }
    //연령대
    Agerender() {
        let AgeModel = this.state.AgeModel;
        if (AgeModel.length > 0) {
            return (
                <div className="resister_input_line">
                    <label>연령대 입력</label>
                    <div className="choice_box_s">
                        {
                            AgeModel.map(list =>
                                <div className="selected_item" key={list.Age_Cd}>
                                    <div className="selected_name">{list.Age_Nm}</div>
                                    <div className="item_delete" onClick={(e) => { this.handleDelete_Click(e, "AgeModel", "Age_Cd", list.Age_Cd) }}></div>
                                </div>
                            )
                        }
                        <div className="go_arrow" onClick={(e) => { this.handleAgeClick(e); }}></div>
                    </div>
                    <div className="input_txt_v2">※ 연령대 입력은 필수등록사항은 아니지만 등록 시 상품상위 노출에 도움이 됩니다.</div>
                </div>
            )
        }
        else {
            return (
                <div className="resister_input_line">
                    <label>연령대 입력</label>
                    <div className="choice_box">
                        <div className="go_txt">연령대 선택하기</div>
                        <div className="go_arrow" onClick={(e) => { this.handleAgeClick(e); }}></div>
                    </div>
                    <div className="input_txt_v2">※ 연령대 입력은 필수등록사항은 아니지만 등록 시 상품상위 노출에 도움이 됩니다.</div>
                </div>
            )
        }
    }
    
    render() {
        let Categoryrender = this.Categoryrender();
        let Colorender = this.Colorender();
        let Sizerender = this.Sizerender();
        let SizeDtl = this.SizeDtlrender();
        let Materialrender = this.Materialrender();
        let Matcharender = this.Matcharender();
        let Ladryrender = this.Ladryrender();
        let Productrender = this.Productrender();
        let GoodsImagerender = this.GoodsImagerender();
        let Stylerender = this.Stylerender();
        let Agerender = this.Agerender();
        return (
            <div>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap"><div className="alert_tap tap_on">상품등록</div></div>
                    <div className="n_tap"><div className="alert_tap"><Link to="/Goods/GoodsMgr/Index" onClick={(e) => { this.handleInputCheck_Click(e) }}>상품관리</Link></div></div>
                </div>
                <div className="resister_box">
                    <div className="resister_input_line">
                        <label>상품명</label>
                        <input type="text"
                            className="form-control"
                            maxLength="30"
                            id="Goods_Nm"
                            value={this.state.GoodsMgtModel.Goods_Nm}
                            placeholder="상품명을 입력(최대 30자)해주세요."
                            onChange={this.handleChange}
                        />
                    </div>
                    {GoodsImagerender}
                    
                    <div className="resister_input_line">
                        <label>상품단가</label>
                        <input type="text"
                            id="Goods_Price"
                            className="form-control"
                            maxLength="10"
                            placeholder="숫자만 직접입력해주세요."
                            value={this.state.GoodsMgtModel.Goods_Price}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                        <div className="price_select">
                            <div className="price" onClick={(e) => { this.handlePrice_Click(e, 50000) }}>5만원</div>
                            <div className="price" onClick={(e) => { this.handlePrice_Click(e, 10000) }}>1만원</div>
                            <div className="price" onClick={(e) => { this.handlePrice_Click(e, 5000) }}>5천원</div>
                            <div className="price" onClick={(e) => { this.handlePrice_Click(e, 1000) }}>1천원</div>
                            <div className="price" onClick={(e) => { this.handlePrice_Click(e, 500) }}>5백원</div>
                            <div className="price" onClick={(e) => { this.handlePrice_Click(e, 100) }}>1백원</div>
                        </div>
                        <div className="Material_select_box item_hide" >
                            <div className="form-check">
                                <input className="form-check-input"
                                    type="checkbox"
                                    id="Strqst_Yn"
                                    onChange={this.handleChange}
                                    checked={this.state.GoodsMgtModel.Strqst_Yn}
                                />
                                <label className="form-check-label">
                                    매장문의
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="resister_input_line">
                        <label>상품 상세설명</label>
                        <textarea className="form-control textarea"
                            id="Dtl_Content"
                            rows="5"
                            placeholder="상품 상세설명을 입력해주세요."
                            onChange={this.handleChange}
                            defaultValue={this.state.GoodsMgtModel.Dtl_Content}>
                        </textarea>
                        <div className="auto_txt_box">
                            <div className="auto_txt" onClick={(e) => { this.handleDescInput_Click(e, 1); }}>자동입력1</div>
                            <div className="auto_txt" onClick={(e) => { this.handleDescInput_Click(e, 2); }}>자동입력2</div>
                            <div className="auto_txt" onClick={(e) => { this.handleDescInput_Click(e, 3); }}>자동입력3</div>
                        </div>
                    </div>
                    {Categoryrender}
                    {Colorender}
                    {Sizerender}
                    {SizeDtl }
                    {Materialrender}
                    {Matcharender}
                    {Ladryrender}
                    {Productrender}
                    <div className="resister_input_line">
                        <label>공개방식</label>
                        <div className="country_select_box v2">
                            <div className="form-check">
                                <input className="form-check-input"
                                    type="radio"
                                    name="Public_Yn"
                                    value="Y"
                                    onChange={this.handleChange}
                                    checked={this.state.GoodsMgtModel.Public_Yn === "Y" ? "checked" : ""}
                                />
                                <label className="form-check-label">
                                    전체공개
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input"
                                    type="radio"
                                    name="Public_Yn"
                                    value="N"
                                    onChange={this.handleChange}
                                    checked={this.state.GoodsMgtModel.Public_Yn === "N" ? "checked" : ""}
                                />
                                <label className="form-check-label">
                                    거래처공개
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="resister_input_line">
                        <label>낱장 판매여부</label>
                        <div className="country_select_box">
                            <div className="form-check">
                                <input className="form-check-input"
                                    type="radio"
                                    name="Sinsale_Yn"
                                    value="Y"
                                    onChange={this.handleChange}
                                    checked={this.state.GoodsMgtModel.Sinsale_Yn === "Y" ? "checked" : ""}
                                />
                                <label className="form-check-label">
                                    낱장가능
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input"
                                    type="radio"
                                    name="Sinsale_Yn"
                                    value="N"
                                    onChange={this.handleChange}
                                    checked={this.state.GoodsMgtModel.Sinsale_Yn === "N" ? "checked" : ""}
                                />
                                <label className="form-check-label">
                                    낱장불가
                                </label>
                            </div>
                        </div>
                    </div>
                    {Agerender}
                    {Stylerender}
                </div>
                <div className="resister_button_box">
                    <button type="button" className="r_btn_v btn_v1" onClick={(e) => { this.handleComponent_Click(e, 'GoodsPre'); }}>미리보기</button>
                    <button type="button" className="r_btn_v btn_v1" onClick={this.handleRegister_Click}>상품등록</button>
                </div>
                <Alert
                    id="GoodsRegAlert"
                    title={this.state.Title}
                    content={this.state.Content}
                />
                <DescInput
                    id="DescInput"
                    ref={this.refDescInput}
                    Callback={this.handleCallBack}
                />
                <StyleKeyword
                    id="StyleKeyword"
                    ref={this.StyleKeywordRef}
                    Callback={this.handleStyleCallBack}
                />
                <Age
                    id="Age"
                    ref={this.AgeRef}
                    Callback={this.handleAgeCallBack}
                />
            </div>
        );
    }
}
